// extracted by mini-css-extract-plugin
export default {"table_cell":"TableCell_table_cell__gHqa6","tooltip":"TableCell_tooltip__6Ox8h","tooltiptext":"TableCell_tooltiptext__PHA+Q"};